import { apiClient } from './client';

export interface SetScore {
  home: number;
  away: number;
}

export interface MatchResult {
  id: number;
  sets?: SetScore[];
  home_sets_won: number;
  away_sets_won: number;
  status: 'pending' | 'confirmed' | 'rejected';
  rejection_note?: string;
  submitted_at?: string;
  confirmed_at?: string;
  submitter?: { id: string; first_name: string; last_name: string };
  confirmer?: { id: string; first_name: string; last_name: string };
  admin_edited_by?: string | null;
  admin_editor?: { id: string; first_name: string; last_name: string } | null;
  admin_edited_at?: string | null;
}

export interface PairPlayer {
  id: string;
  first_name: string;
  last_name: string;
  level?: string;
  photo_url?: string;
}

export interface MatchPair {
  id: number;
  player1?: PairPlayer | null;
  player2?: PairPlayer | null;
}

export interface Match {
  id: number;
  league_id: number;
  group_id?: number;
  phase: string;
  round?: number;
  match_number?: number;
  home_player_id?: string | null;
  away_player_id?: string | null;
  home_pair_id?: number | null;
  away_pair_id?: number | null;
  winner_pair_id?: number | null;
  is_bye: boolean;
  winner_id?: string | null;
  status: 'pending' | 'result_submitted' | 'confirmed' | 'cancelled';
  next_match_id?: number | null;
  created_at: string;
  home_player?: { id: string; first_name: string; last_name: string; level?: string; photo_url?: string } | null;
  away_player?: { id: string; first_name: string; last_name: string; level?: string; photo_url?: string } | null;
  winner?: { id: string; first_name: string; last_name: string } | null;
  home_pair?: MatchPair | null;
  away_pair?: MatchPair | null;
  winner_pair?: MatchPair | null;
  result?: MatchResult;
}

export const matchesApi = {
  get: (id: number) => apiClient.get<Match>(`/api/matches/${id}`),

  submitResult: (id: number, sets: SetScore[]) =>
    apiClient.post(`/api/matches/${id}/result`, { sets }),

  confirm: (id: number) => apiClient.post(`/api/matches/${id}/confirm`),

  reject: (id: number, note: string) =>
    apiClient.post(`/api/matches/${id}/reject`, { note }),

  adminEdit: (id: number, sets: SetScore[], note?: string) =>
    apiClient.put(`/api/matches/${id}/result`, { sets, note }),
};
